import axiosClient from "../axiosClient";

export type SubmitFeedbackResponse = {
  feedback: { id: number; createdAt: string };
  message: string;
};

export async function submitFeedback(text: string): Promise<SubmitFeedbackResponse> {
  const response = await axiosClient.post("/feedback", { text });
  const responseData: SubmitFeedbackResponse = response.data;
  return responseData;
}
